import { addToGlobalThisRet } from "@plugins";

const tooltipOptions = {
    placement: "top",
    arrow: false,
};

function initCalendarCellFilling() {
    const tooltipTriggers = document.querySelectorAll(".js-simple-calendar-tooltip-init");

    if (tooltipTriggers) {
        tooltipTriggers.forEach((trigger) => {
            trigger.classList.add("filled");
        });
    }
}

window.addEventListener("load", () => {
    initCalendarCellFilling();
    globalThis.ret.initContentTooltips(".js-simple-calendar-tooltip-init", tooltipOptions);
});

addToGlobalThisRet(initCalendarCellFilling, "initCalendarCellFilling");
